import store from '../store'
export default function auth({ next, router, to }) {
  if (store.getters["auth/getUser"] == null) {
    return router.replace({name: "login", query: {redirect: to.fullPath}});
  }
  return next();
}

